import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CartService } from 'src/app/services/cart.service';
import { CheckoutPreview, Order, CheckoutReqGT } from 'src/app/models/cart';
import { ProductService } from 'src/app/services/product.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { LazyLoaderService } from 'src/app/services/lazy-loader.service';
import { AlertComponent } from 'src/app/alert/alert.component';
import { SetPinType } from 'src/app/models/account';
import { InputPinComponent } from 'src/app/pin-limit/shared/input-pin/input-pin.component';
import { v4 as uuid } from 'uuid';
import * as firebase from 'firebase';
import { isNullOrUndefined } from 'util';
import { DetailHargaComponent } from 'src/app/detail-harga/detail-harga.component';

declare var $: any;

@Component({
  selector: 'app-checkout-gt',
  templateUrl: './checkout-gt.component.html',
  styleUrls: ['./checkout-gt.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CheckoutGtComponent implements OnInit {
public checkoutData: CheckoutPreview = null;
  public addressList: UserAddress[] = [];
  public currentAddress: UserAddress = null;
  public selectedAddress: UserAddress = null;
  public chooseOtherAddress = false;
  public totalItem = 0;
  public fileName = '';
  public fileSize = 0;
  public filepath;
  public alertNomorSP = '';
  public alertFileSize = '';
  hasNetPrice = false;
  netPrice = 0;
  netTotalValue = 0;
  subTotalValue = 0;
  tax = 0;
  listDiscount = [];
  totalDiscount = 0;
  limit = 0;
  limitIsOn = false;
  priceBeforeTax = 0;

  public checkoutReq: CheckoutReqGT = new CheckoutReqGT();

  // public startDate = '';
  // public endDate = '';

  @ViewChild('alertComponent') alertComponent: AlertComponent;
  @ViewChild(InputPinComponent) inputPin: InputPinComponent;
  @ViewChild('detailHargaComponent') detailHargaComponent: DetailHargaComponent;
  
  constructor(private router: Router,
    private addressService: AuthenticationService,
    private cartService: CartService,
    public productService: ProductService,
    private lazyLoaderService: LazyLoaderService,
    private authService: AuthenticationService) {
    window.scrollTo(0, 0);
  }

  get getPinStep() { return SetPinType; }

  ngOnInit() {
    this.lazyLoaderService.loadScript('https://cdn.jsdelivr.net/npm/gijgo@1.9.6/js/gijgo.min.js');

    this.loadlimit();
    // this.checkoutReq.RequestId = uuid();
    this.getCheckoutPreview();
    this.getAddressList();
    $('#gtModal').removeClass('d-flex align-items-center');

    $('#gtModal').on('hidden.bs.modal', function () {
      $(this).removeClass('d-flex align-items-center');
    });
    //this.loadJQueryScript();
  }

  // loadJQueryScript(): void {
  //   const that = this;

  //   $('#startDate').datepicker('destroy');

  //   $('#startDate').datepicker({
  //     uiLibrary: 'bootstrap4',
  //     format: 'yyyy-mm-dd',
  //     minDate: that.startDate,
  //     maxDate: that.endDate,
  //     change: function (e) {
  //       startDateOnChanged(e);
  //     }
  //   });

  //   function startDateOnChanged(event) {
  //     that.checkoutReq.PODate = $('#startDate').val();
  //   }
  // }

  getAddressList(): void {
    this.addressService.getAddresss(
      (data) => {
        this.addressList = data as UserAddress[];
        if (this.addressList.length > 0) {
          this.currentAddress = this.addressList[0];
          this.selectedAddress = this.currentAddress;
          this.checkoutReq.Address = this.currentAddress.address;
          this.checkoutReq.ShipToPartyCode = this.currentAddress.ship_to_party_code;
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getCheckoutPreview(): void {
    this.cartService.checkoutPreview(
      (data) => {
        if (data === undefined) {
          this.checkoutData = null;
        } else {
          this.checkoutData = data as CheckoutPreview;

          // const start = new Date(new Date().getTime() + (this.checkoutData.initial_buffer * 24 * 60 * 60 * 1000));
          // const end = new Date(new Date().getTime() + (this.checkoutData.maximum_buffer * 24 * 60 * 60 * 1000));

          // this.startDate = start.toISOString().slice(0, 10);
          // this.endDate = end.toISOString().slice(0, 10);

          //this.checkoutReq.PODate = new Date().toISOString().slice(0, 10);

          this.countTotalItem();
          this.updateCheckoutPromo();//CR10
          //this.loadJQueryScript();
        }

        $('#loader').modal('hide');
      },
      (err) => {
        this.alertComponent.show(err.code, err.message);
      }
    );
  }

  //CR10
  updateCheckoutPromo() {
    const products = [];

    this.checkoutData.orders.forEach(element => {
      const item = {
        productCode: element.product_code,
        quantity: element.quantity
      };
      products.push(item);
    });

    const obj = {
      customerCode: JSON.parse(localStorage.getItem('user-profile')).customer_code,
      products
    }

    //data dummy
    // const obj = {
    //   customerCode: "100885",
    //   products: [
    //     {
    //       productCode: "SHPDS60N",
    //       quantity: 10
    //     }
    //   ]
    // }

    this.cartService.updateCartPromo(obj,
      data => {
        this.netTotalValue = data.netTotalValue;
        this.subTotalValue = data.subTotalValue;
        this.tax = data.tax;
        this.totalDiscount = data.totalDiscValue;
        this.priceBeforeTax = data.beforeTax;

        let listPromotions = [];
        data.products.forEach(item => {
          listPromotions.push(item.promotions);
        });

        this.listDiscount = listPromotions.reduce((accumulator, value) => accumulator.concat(value), []);
        this.hasNetPrice = true;
        this.netPrice = data.netTotalValue; // + data.tax;

        for (let i = 0; i < data.products.length; i++) {
          if (data.products[i] && this.checkoutData.orders[i]) {
            this.checkoutData.orders[i].price = data.products[i].productPriceNetValue;
            this.checkoutData.orders[i].total_price = data.products[i].netValue;
          }
        }

        if (listPromotions.length === 0) {
          $('#btn-detail-harga').addClass('d-none');
        }
      },
      () => {
        $('#btn-detail-harga').addClass('d-none');
      });
  }

  countTotalItem(): void {
    if (this.checkoutData.orders !== undefined && this.checkoutData.orders !== null) {
      this.checkoutData.orders.forEach(element => {
        this.totalItem += element.quantity;
      });
    }
  }

  onAddressChanged(): void {
    const address = this.addressList.filter(x => x.ship_to_party_code === this.checkoutReq.ShipToPartyCode)[0] as UserAddress;
    if (address !== null && address !== undefined) {
      this.selectedAddress = address;
    }
  }

  chooseOtherAddressClicked(): void {
    if (this.chooseOtherAddress) {
      this.chooseOtherAddress = false;
    } else {
      this.chooseOtherAddress = true;
    }

    // code shorten by CR10
    // this.chooseOtherAddress = !this.chooseOtherAddress;
  }

  applyNewAddress(): void {
    this.chooseOtherAddress = false;
    this.currentAddress = this.addressList.filter(x => x.ship_to_party_code === this.checkoutReq.ShipToPartyCode)[0];
  }

  cancelNewAddress(): void {
    this.chooseOtherAddress = false;
  }

  onFileChanged(files: FileList): void {
    firebase.analytics().logEvent('order_pilihberkas_button');

    this.fileName = '';
    this.fileSize = 0;

    if (files.length > 0) {
      const file = files.item(0);

      const file_size = file.size / 1024 / 1024;

      if (file_size <= 25) {
        this.alertFileSize = '';
        this.fileName = file.name;
        this.fileSize = file_size;

        this.checkoutReq.File = file;
      } else {
        this.alertFileSize = 'Ukuran file maksimal 25MB';
        this.checkoutReq.File = undefined;
      }
    } else {
      this.checkoutReq.File = undefined;
    }
  }

  setPin(pin: string) {
    // this.checkoutReq.Pin = pin;
    $('#askPin').modal('hide');
    this.confirm(true);
  }

  loadlimit() {
    this.authService.getLimit(
      resp => {
        if (resp.alert.code === 200) {
          this.limit = resp.data.limit;
          this.limitIsOn = resp.data.isOn;
        } else {
          console.log(resp);
        }
      },
      err => {
        console.log(err);
      });
  }

  confirm(isValid: boolean): void {
    // if (!this.checkGT()) {
    //   return;
    // }

    if (this.checkoutData === null) {
      this.alertComponent.show('400', 'Sorry, cart is empty');
      return;
    }

    if (this.checkoutReq.PurchaseOrderNumber && !this.checkoutReq.PurchaseOrderNumber.replace(/\s/g, '').length) {
      this.alertNomorSP = 'Nomor SP harus diisi';
      return;
    }

    this.alertNomorSP = '';

    if (!isValid || this.checkoutReq.File === undefined) {
      return;
    }

    firebase.analytics().logEvent('order_konfirmasi_pesanan_button');

    // const data = this.authService.getProfileData();
    //   if (data !== undefined && data !== null) {
    //     if((data.limit < this.checkoutData.grand_total) && (this.checkoutReq.Pin === '' || this.checkoutReq.Pin === undefined)){
    //       this.inputPin.showError('');
    //       $('#askPin').modal('show');
    //       return;
    //     }
    //   }
    // if ((this.limitIsOn === true && this.limit < this.checkoutData.grand_total) && (this.checkoutReq.Pin === '' || this.checkoutReq.Pin === undefined)) {
    //   this.inputPin.showError('');
    //   $('#askPin').modal('show');
    //   return;
    // }
    $('#loader').modal('show');

    this.cartService.checkoutGt(this.checkoutReq,
      (data) => {
        $('#loader').modal('hide');
        this.router.navigate([`/transaction/${data.id}/select-payment`]);
      },
      (err) => {
        $('#loader').modal('hide');
        // if (err.code === 403) {
        //   this.checkoutReq.Pin = '';
        //   this.inputPin.showError(err.message);
        //   $('#askPin').modal('show');
        // } else {
          this.alertComponent.show('Pesanan Gagal Dibuat', 'Pesanan Anda gagal karena terdapat produk yang bermasalah');
        // }
      }
    );
  }

  detailHarga() {
    this.detailHargaComponent.show(this.subTotalValue, this.totalDiscount, this.listDiscount, this.tax, this.netTotalValue, this.priceBeforeTax);
  }

  checkGT() {
    const isGT = localStorage.getItem('gtStatus');
    const top = localStorage.getItem('topStatus');

    if (isGT === 'true' && top === 'true') {
      return true;
    }

    $(".nonGtModal").addClass('d-flex align-items-center');
    $(".nonGtModal").modal("toggle");
    return false;
  }
}
